import React, { Component } from 'react';
import './Artist.css';
import axios from 'axios';
import Press from './Press';
import Calendar from './Calendar';
import IconLinkList from './Iconlist';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Image from 'react-bootstrap/lib/Image';
import Title from '../objs/Title';
let back = 'https://backend.themusiccompany.dk';

class AgentDetail extends Component {
  render() {
    if (this.props.agent2) {
      var s = 's';
      var agent2 = (
        <p className="agentInfo">
          {this.props.agent2.name}
          <br />
          <a className="whiteLink" href={'mailto:' + this.props.agent.email}>
            {this.props.agent2.email}
          </a>
        </p>
      );
    }
    return (
      <div className="left">
        <p className="agentHead">
          {this.props.type}
          {s}
        </p>
        <p className="agentInfo">
          {this.props.agent.name}
          <br />
          <a className="whiteLink" href={'mailto:' + this.props.agent.email}>
            {this.props.agent.email}
          </a>
        </p>
        {agent2}
      </div>
    );
  }
}
// (this.props.manager ? null : <Col sm={6} md={6}><AgentDetail agent={this.props.manager} /></Col>)
class Neck extends Component {
  render() {
    if (this.props.manager) {
      var manager = (
        <Col sm={6} md={6}>
          <AgentDetail
            type="Manager"
            agent={this.props.manager}
            agent2={this.props.manager2}
          />
        </Col>
      );
    }
    if (this.props.agent) {
      var agent = (
        <Col sm={6} md={6}>
          <AgentDetail
            type="Agent"
            agent={this.props.agent}
            agent2={this.props.agent2}
          />
        </Col>
      );
    }
    if (this.props.manager && this.props.agent) {
      var block = (
        <div>
          <Row className="neck">
            {agent}
            <Col sm={6} md={6} className="high_iconList">
              <IconLinkList links={this.props.links} />
            </Col>
          </Row>
          <Row
            className="neck"
            style={{ marginTop: '10px', marginBottom: '10px' }}
          >
            {manager}
          </Row>
          <Row className="neck">
            <Col sm={6} md={6} className="low_iconList">
              <IconLinkList links={this.props.links} />
            </Col>
          </Row>
        </div>
      );
    } else {
      block = (
        <Row className="neck">
          {agent}
          {manager}
          <Col sm={6} md={6}>
            <IconLinkList links={this.props.links} />
          </Col>
        </Row>
      );
    }
    return <div>{block}</div>;
  }
}

class Maintext extends Component {
  render() {
    return (
      <Row>
        <Col xs={12} lg={12}>
          <p className="mainText">
            {this.props.text.split('\n').map((item, key) => {
              return (
                <span key={key}>
                  {item}
                  <br />
                </span>
              );
            })}
          </p>
        </Col>
      </Row>
    );
  }
}

class Tt extends Component {
  constructor(props) {
    super(props);
    this.state = { maintext: null, calendar: null, press: null };
    this.update = this.update.bind(this);
  }
  update() {
    if (
      this.props.obj.press_document.length === 0 &&
      this.props.obj.press_image.length === 0
    ) {
      this.setState({ press: null });
    } else {
      this.setState({
        press: (
          <Press
            imgs={this.props.obj.press_image}
            docs={this.props.obj.press_document}
          />
        ),
      });
    }
    if (this.props.obj.newcalendar.length === 0) {
      this.setState({ calendar: null });
    } else {
      this.setState({
        calendar: <Calendar calendar={this.props.obj.newcalendar} />,
      });
    }
    if (this.props.obj.text === '') {
      this.setState({ maintext: null });
    } else {
      this.setState({ maintext: <Maintext text={this.props.obj.text} /> });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.update();
    }
  }
  componentDidMount() {
    this.update();
  }
  render() {
    return (
      <Row className="art">
        <Image
          alt={this.props.name}
          className="headimg"
          responsive
          src={this.props.obj.image.big}
        />
        <Neck
          className="neck"
          agent={this.props.obj.agent}
          manager={this.props.obj.manager}
          agent2={this.props.obj.agent2}
          manager2={this.props.obj.manager2}
          links={this.props.obj.links}
        />
        {this.state.maintext}
        {this.state.calendar}
        {this.state.press}
      </Row>
    );
  }
}

class Artist extends Component {
  constructor(props) {
    super(props);
    this.state = { artist: null, hideArtist: null };
    this.updateArtist = this.updateArtist.bind(this);
  }
  updateArtist() {
    this.props.update(this.props.location.pathname);
    if (this.props.location.pathname === '') {
      this.setState({ hideArtist: 'none' });
    } else {
      this.setState({ hideArtist: 'block' });
    }
    var slug = this.props.match.params.name
      .replace('(', '_')
      .replace(')', '')
      .replace(/ /g, '_')
      .replace(/\./g, '');
    axios.get(back + '/artist/' + slug + '?format=json').then((res) => {
      const art = <Tt key={res.data.id} obj={res.data} />;
      this.setState({ artist: art });
    });
  }
  componentWillUnmount() {
    this.props.menuClick();
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.updateArtist();
    }
  }
  componentDidMount() {
    this.updateArtist();
  }

  render() {
    return (
      <Row style={{ display: this.state.hideArtist }} className="artists art">
        <Title title={this.props.match.params.name} className="title_white" />
        <div className="wrap">{this.state.artist}</div>
      </Row>
    );
  }
}

export default Artist;



// WEBPACK FOOTER //
// ./src/artist/Artist.js